var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent100 centering"},[_c('ResultSceneBackground',{attrs:{"rarity":_vm.currenRarity}}),_c('div',{staticClass:"img-wrap",style:(_vm.tdStyle)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }